import { render, staticRenderFns } from "./ViewVideoDialog.vue?vue&type=template&id=61daf27e&"
import script from "./ViewVideoDialog.vue?vue&type=script&lang=js&"
export * from "./ViewVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ViewVideoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports